module.exports = __webpack_public_path__ + "img/read.b0c3b6a2.svg";